import { useEffect } from 'react';
import { View } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withDelay, withSpring, withTiming } from 'react-native-reanimated';
type StarBurstAnimationProps = Readonly<{
  visible: boolean;
  setShowAnimation: (showAnimation: boolean) => void;
}>;
const STARS = [
  { x: 0, delay: 0 },
  { x: -80, delay: 80 },
  { x: 80, delay: 80 },
  { x: -140, delay: 160 },
  { x: 140, delay: 160 },
  { x: -40, delay: 120 },
  { x: 40, delay: 120 },
];
const StarParticle = ({ x, delay, trigger }: { x: number; delay: number; trigger: boolean }) => {
  const scale = useSharedValue(0);
  const translateY = useSharedValue(0);
  const translateX = useSharedValue(0);
  const opacity = useSharedValue(0);
  useEffect(() => {
    if (!trigger) return;
    scale.value = 0;
    translateY.value = 0;
    translateX.value = 0;
    opacity.value = 1;
    scale.value = withDelay(delay, withSpring(1.2));
    translateY.value = withDelay(delay, withSpring(-600, { damping: 16, stiffness: 60 }));
    translateX.value = withDelay(delay, withSpring(300 + x * 0.4, { damping: 10, stiffness: 80 }));
    opacity.value = withDelay(delay + 400, withTiming(0, { duration: 400 }));
  }, [trigger]);
  const style = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }, { translateY: translateY.value }, { scale: scale.value }],
    opacity: opacity.value,
    position: "absolute",
    fontSize: 36,
  }));
  return <Animated.Text style={style}>⭐</Animated.Text>;
};
const StarBurstAnimation = ({ visible = false, setShowAnimation }: StarBurstAnimationProps) => {
  useEffect(() => {
    if (visible) {
      setTimeout(() => setShowAnimation(false), 2000);
    }
  }, [visible]);
  return (
    <View
      className={visible ? "" : "hidden"}
      style={{
        position: "absolute",
        zIndex: 9999,
        elevation: 9999,
        top: 0, left: 0, right: 0, bottom: 0,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        pointerEvents: "none",
      }}
    >
      {STARS.map((s, i) => (
        <StarParticle key={i} x={s.x} delay={s.delay} trigger={visible} />
      ))}
    </View>
  );
};
export default StarBurstAnimation;


